import store from '@/store'
import {
  removeBaseToken,
  removeToken,
  setToken
} from '@/axios/cookies'

export function hasUserIdentity (user) {
  return Boolean(user && (user.uid || user.id || user.loginName))
}

export function getStoredUserInfo () {
  const storedUserInfo = sessionStorage.getItem('userInfo')
  if (!storedUserInfo) return {}
  try {
    const userInfo = JSON.parse(storedUserInfo)
    return userInfo && typeof userInfo === 'object' ? userInfo : {}
  } catch (error) {
    return {}
  }
}

export function saveUserInfo (userInfo) {
  const normalizedUser = userInfo || {}
  sessionStorage.setItem('userInfo', JSON.stringify(normalizedUser))
  store.commit('SET_USERINFO', normalizedUser)
}

export function clearUserInfo () {
  sessionStorage.removeItem('userInfo')
  store.commit('reset')
}

export function clearUserSession () {
  removeToken()
  removeBaseToken()
  clearUserInfo()
}

export function refreshUserInfo (userInfoResponse) {
  const storedUserInfo = getStoredUserInfo()
  const distributor = userInfoResponse && userInfoResponse.distributor
  const normalizedUser = distributor && typeof distributor === 'object'
    ? Object.assign({}, storedUserInfo, distributor)
    : Object.assign({}, storedUserInfo, userInfoResponse || {})

  if (hasUserIdentity(normalizedUser)) {
    saveUserInfo(normalizedUser)
  }
  return normalizedUser
}

export function setUserToken (token, expiresTime) {
  removeBaseToken()
  setToken(token, expiresTime)
}
